import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/ui/popup/popup_position_controller.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["fullScreen", "forceApplyBindings", "dragOutsideBoundary", "dragAndResizeArea", "outsideDragFactor"];
import $ from "../../core/renderer";
import { move } from "../../animation/translator";
import { getWindow } from "../../core/utils/window";
import { originalViewPort } from "../../core/utils/view_port";
import { OverlayPositionController } from "../overlay/overlay_position_controller";
var window = getWindow();

var PopupPositionController =
/*#__PURE__*/
function (_OverlayPositionContr) {
  _inherits(PopupPositionController, _OverlayPositionContr);

  function PopupPositionController(_ref) {
    var _this;

    _classCallCheck(this, PopupPositionController);

    var fullScreen = _ref.fullScreen,
        forceApplyBindings = _ref.forceApplyBindings,
        dragOutsideBoundary = _ref.dragOutsideBoundary,
        dragAndResizeArea = _ref.dragAndResizeArea,
        outsideDragFactor = _ref.outsideDragFactor,
        args = _objectWithoutPropertiesLoose(_ref, _excluded);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PopupPositionController).call(this, args));
    _this._props = _extends({}, _this._props, {
      fullScreen: fullScreen,
      forceApplyBindings: forceApplyBindings,
      dragOutsideBoundary: dragOutsideBoundary,
      dragAndResizeArea: dragAndResizeArea,
      outsideDragFactor: outsideDragFactor
    });
    _this._$dragResizeContainer = void 0;
    _this._outsideDragFactor = void 0;
    _this._lastPositionBeforeFullScreen = void 0;

    _this._updateDragResizeContainer();

    _this._updateOutsideDragFactor();

    return _this;
  }

  _createClass(PopupPositionController, [{
    key: "updateContainer",
    value: function updateContainer(containerProp) {
      _get(_getPrototypeOf(PopupPositionController.prototype), "updateContainer", this).call(this, containerProp);

      this._updateDragResizeContainer();
    }
  }, {
    key: "dragHandled",
    value: function dragHandled() {
      this.restorePositionOnNextRender(false);
    }
  }, {
    key: "resizeHandled",
    value: function resizeHandled() {
      this.restorePositionOnNextRender(false);
    }
  }, {
    key: "positionContent",
    value: function positionContent() {
      if (this._props.fullScreen) {
        move(this._$content, {
          top: 0,
          left: 0
        });
        this.detectVisualPositionChange();
      } else {
        var _this$_props$forceApp, _this$_props;

        null === (_this$_props$forceApp = (_this$_props = this._props).forceApplyBindings) || void 0 === _this$_props$forceApp ? void 0 : _this$_props$forceApp.call(_this$_props);

        if (!this._shouldRenderContentInitialPosition && this._lastPositionBeforeFullScreen) {
          move(this._$content, this._lastPositionBeforeFullScreen);
          this._lastPositionBeforeFullScreen = void 0;
          this.detectVisualPositionChange();
        } else {
          _get(_getPrototypeOf(PopupPositionController.prototype), "positionContent", this).call(this);
        }
      }
    }
  }, {
    key: "_updateOutsideDragFactor",
    value: function _updateOutsideDragFactor() {
      this._outsideDragFactor = this._getOutsideDragFactor();
    }
  }, {
    key: "_getOutsideDragFactor",
    value: function _getOutsideDragFactor() {
      if (this._props.dragOutsideBoundary) {
        return 1;
      }

      return this._props.outsideDragFactor;
    }
  }, {
    key: "_updateDragResizeContainer",
    value: function _updateDragResizeContainer() {
      this._$dragResizeContainer = this._getDragResizeContainer();
    }
  }, {
    key: "_getDragResizeContainer",
    value: function _getDragResizeContainer() {
      if (this._props.dragOutsideBoundary) {
        return $(window);
      }

      if (this._props.dragAndResizeArea) {
        return $(this._props.dragAndResizeArea);
      }

      var isContainerDefined = originalViewPort().get(0) || this._props.container;

      return isContainerDefined ? this._$markupContainer : $(window);
    }
  }, {
    key: "_getVisualContainer",
    value: function _getVisualContainer() {
      if (this._props.fullScreen) {
        return $(window);
      }

      return _get(_getPrototypeOf(PopupPositionController.prototype), "_getVisualContainer", this).call(this);
    }
  }, {
    key: "_fullScreenEnabled",
    value: function _fullScreenEnabled() {
      this.restorePositionOnNextRender(false);
      this._lastPositionBeforeFullScreen = this._visualPosition;
    }
  }, {
    key: "_fullScreenDisabled",
    value: function _fullScreenDisabled() {
      this.restorePositionOnNextRender(false);
    }
  }, {
    key: "fullScreen",
    set: function set(fullScreen) {
      this._props.fullScreen = fullScreen;

      if (fullScreen) {
        this._fullScreenEnabled();
      } else {
        this._fullScreenDisabled();
      }
    }
  }, {
    key: "$dragResizeContainer",
    get: function get() {
      return this._$dragResizeContainer;
    }
  }, {
    key: "outsideDragFactor",
    get: function get() {
      return this._outsideDragFactor;
    },
    set: function set(outsideDragFactor) {
      this._props.outsideDragFactor = outsideDragFactor;

      this._updateOutsideDragFactor();
    }
  }, {
    key: "dragAndResizeArea",
    set: function set(dragAndResizeArea) {
      this._props.dragAndResizeArea = dragAndResizeArea;

      this._updateDragResizeContainer();
    }
  }, {
    key: "dragOutsideBoundary",
    set: function set(dragOutsideBoundary) {
      this._props.dragOutsideBoundary = dragOutsideBoundary;

      this._updateDragResizeContainer();

      this._updateOutsideDragFactor();
    }
  }]);

  return PopupPositionController;
}(OverlayPositionController);

export { PopupPositionController };